{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "Yükselt",
    "navBilling": "Faturalandırma"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "Senin sekmen. Senin <em>zikrin</em>.<br />Yükseltildi.",
    "subtitle": "Daha bilinçli bir gün için ihtiyacınız olan her özellik — namaz vakitlerinden ve AI ayet tefekküründen hava durumuna ve öncelikli görevlere kadar — sakin, güzel tek bir yeni sekmede.",
    "comparison_aria": "Plan karşılaştırması",
    "free": {
      "tierLabel": "Mevcut",
      "tierName": "Ücretsiz",
      "freeLabel": "Her zaman ücretsiz",
      "list_aria": "Ücretsiz plan özellikleri"
    },
    "pro": {
      "list_aria": "Pro plan özellikleri",
      "tierLabel": "Şuna yükselt",
      "tierName": "Pro",
      "pricePeriod": "/ ay",
      "priceAlt": "veya yıllık $39.99"
    },
    "freeFeatures": {
      "clockDate": "Saat ve tarih göstergesi",
      "verseOfDay": "Günün Kuran ayeti",
      "dailyBackground": "Günlük arka plan fotoğrafı",
      "qiblaCompass": "Kıble pusulası",
      "basicTasks": "Temel görevler"
    },
    "proFeatures": {
      "weatherForecast": "5 günlük hava durumu tahmini",
      "verseFavorites": "Favori ayetleri kaydet ve gözat",
      "notesAi": "AI analizli notlar",
      "priorityTasks": "Öncelikli görev yönetimi",
      "verseReflection": "AI ile ayet tefekkürü"
    },
    "plans": {
      "monthly": {
        "label": "Aylık",
        "price": "$4.99",
        "period": "/ ay",
        "note": "Aylık faturalandırılır"
      },
      "yearly": {
        "label": "Yıllık",
        "price": "$39.99",
        "period": "/ yıl",
        "note": "İki ay ücretsiz",
        "badge": "%33 tasarruf"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "İstediğiniz zaman iptal edin. Erişiminiz, kısmi ücret alınmadan faturalandırma döneminin sonuna kadar devam eder.",
    "billingPeriod_aria": "Faturalandırma dönemi",
    "cta": "Güvenli ödemeye devam et",
    "ctaLoading": "Ödemeye yönlendiriliyor…",
    "promoManual": "İndirimini almak için sonraki sayfada {{code}} kodunu gir.",
    "signingUpAs": "{{account}} olarak kaydolunuyor",
    "trustSignals_aria": "Güven işaretleri",
    "reassurance": {
      "secureCheckout": "Stripe ile güvenli ödeme",
      "cancelAnytime": "İstediğiniz zaman iptal, soru sorulmaz",
      "accessUntilEnd": "Dönem sonuna kadar erişim"
    },
    "errors": {
      "restoreSession": "Oturumunuz geri yüklenemedi. Lütfen uzantıdan tekrar deneyin.",
      "checkoutFailed": "Ödeme başlatılamadı. Lütfen tekrar deneyin."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "Açılan özellikler",
    "unlockedFeatures": {
      "weatherForecast": "5 günlük hava durumu tahmini",
      "verseFavorites": "Favori ayetleri kaydet ve gözat",
      "notesAi": "AI analizli notlar",
      "priorityTasks": "Öncelikli görev yönetimi",
      "verseReflection": "AI ile ayet tefekkürü"
    },
    "success": {
      "title": "Pro'ya hoş geldiniz",
      "desc": "Aboneliğiniz etkin. Tüm Pro özelliklerini sizi beklerken bulmak için uzantıya dönün.",
      "viewBilling": "Faturalandırma detaylarını görüntüle",
      "closeTab": "Bu sekmeyi kapat"
    },
    "cancel": {
      "title": "Ödeme iptal edildi",
      "desc": "Endişelenmeyin — planınız değişmedi ve sizden ücret alınmadı. Hazır olduğunuzda istediğiniz zaman yükseltebilirsiniz.",
      "backToUpgrade": "Yükseltmeye geri dön",
      "returnToExtension": "Uzantıya geri dön"
    }
  },
  "billing": {
    "title": "Faturalandırma",
    "subtitle": "Aboneliğinizi yönetin ve ödeme geçmişini görüntüleyin.",
    "subscription_aria": "Abonelik durumu",
    "subscriptionTitle": "Abonelik",
    "loading_aria": "Faturalandırma bilgileri yükleniyor",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Ücretsiz",
    "statusLabels": {
      "active": "Etkin",
      "trialing": "Ücretsiz deneme",
      "past_due": "Vadesi geçmiş",
      "unpaid": "Ödenmemiş",
      "canceled": "İptal edildi",
      "incomplete": "Tamamlanmadı",
      "none": "Abonelik yok"
    },
    "planValues": {
      "proYearly": "Pro · Yıllık",
      "proMonthly": "Pro · Aylık"
    },
    "warnings": {
      "paymentFailedTitle": "Ödeme başarısız",
      "paymentFailedDesc": "Son ödemeniz gerçekleşmedi. Pro erişimini sürdürmek için Faturalandırmayı Yönet üzerinden ödeme yönteminizi güncelleyin.",
      "trialEndingTitle": "Deneme yakında sona eriyor",
      "trialEndingToday": "Ücretsiz denemeniz bugün {{date}} tarihinde sona eriyor. Pro özelliklerinizi korumak için bir ödeme yöntemi ekleyin.",
      "trialEndingInDays_one": "Ücretsiz denemeniz {{count}} gün içinde {{date}} tarihinde sona eriyor. Pro özelliklerinizi korumak için bir ödeme yöntemi ekleyin.",
      "trialEndingInDays_other": "Ücretsiz denemeniz {{count}} gün içinde {{date}} tarihinde sona eriyor. Pro özelliklerinizi korumak için bir ödeme yöntemi ekleyin."
    },
    "cancellationScheduled": "İptal planlandı. <strong>{{date}}</strong> tarihine kadar tam Pro erişiminiz devam eder.",
    "sublabel": {
      "trialEndsToday": "Deneme bugün sona eriyor",
      "trialDaysRemaining_one": "Denemede {{count}} gün kaldı",
      "trialDaysRemaining_other": "Denemede {{count}} gün kaldı",
      "renews": "Yenilenme {{date}}",
      "accessUntil": "{{date}} tarihine kadar erişim"
    },
    "kv": {
      "status": "Durum",
      "nextRenewal": "Sonraki yenilenme",
      "trialEnds": "Deneme sonu",
      "trialDaysLeft_one": "{{count}} gün kaldı",
      "trialDaysLeft_other": "{{count}} gün kaldı",
      "endsToday": "bugün sona eriyor",
      "plan": "Plan"
    },
    "upgradeNudge": {
      "title": "Pro özelliklerinin kilidini aç",
      "desc": "Hava durumu, namaz vakitleri, AI ayet tefekkürü ve daha fazlası — aylık $4.99 veya yıllık $39.99.",
      "cta": "Yükselt"
    },
    "actions": {
      "manageBilling": "Faturalandırmayı ve ödeme yöntemini yönet",
      "cancelConfirmTitle": "Aboneliğinizi iptal etmek istiyor musunuz?",
      "cancelConfirmDesc": "Mevcut faturalandırma döneminizin sonuna kadar tam Pro erişiminizi korursunuz. Kısmi geri ödeme yapılmaz.",
      "canceling": "İptal ediliyor…",
      "yesCancel": "Evet, iptal et",
      "keepPro": "Pro'yu koru",
      "cancelSubscription": "Aboneliği iptal et"
    },
    "noSubscription": "Abonelik bulunamadı.",
    "paymentHistory_aria": "Ödeme geçmişi",
    "paymentHistoryTitle": "Ödeme geçmişi",
    "invoices_aria": "Faturalar",
    "invoiceView": "Görüntüle",
    "invoiceView_aria": "{{date}} tarihli faturayı görüntüle",
    "noInvoices": "Henüz fatura yok.",
    "dangerZone_aria": "Tehlikeli bölge",
    "dangerZoneTitle": "Tehlikeli bölge",
    "deleteAccountTitle": "Hesabı sil",
    "deleteAccountDesc": "Hesabınızı ve ilişkili tüm verileri — görevler, notlar, favoriler ve faturalandırma geçmişi — kalıcı olarak silin. Bu işlem geri alınamaz.",
    "deleteAccountBtn": "Hesabı sil",
    "deleteConfirm": {
      "warning": "Bu işlem anında ve kalıcı olarak:",
      "list": {
        "deleteContent": "Tüm görevlerinizi, notlarınızı ve favori ayetlerinizi siler",
        "cancelSubscription": "Etkin aboneliği iptal eder (kullanılmayan süre için geri ödeme yapılmaz)",
        "removeAccount": "Hesabınızı veritabanımızdan kaldırır",
        "signOut": "Sizi tüm cihazlardan çıkış yaptırır"
      },
      "typeToConfirm": "Onaylamak için <strong>DELETE</strong> yazın",
      "inputPlaceholder": "DELETE",
      "deleting": "Siliniyor…",
      "confirmBtn": "Hesabımı kalıcı olarak sil",
      "cancelBtn": "İptal"
    },
    "errors": {
      "loadFailed": "Faturalandırma bilgileri yüklenemedi.",
      "cancelFailed": "Abonelik iptal edilemedi.",
      "deleteFailed": "Hesap silinemedi. Lütfen tekrar deneyin veya destek ile iletişime geçin.",
      "portalFailed": "Faturalandırma portalı açılamadı."
    }
  },
  "privacy": {
    "tocLabel": "Gizlilik Politikası",
    "toc_aria": "İçindekiler",
    "lastUpdated": "Son güncelleme<br />22 Eylül 2026",
    "sections": {
      "overview": "Genel Bakış",
      "informationWeCollect": "Topladığımız Bilgiler",
      "connectedServices": "Bağlı Hizmetler (Google, Todoist, Apple)",
      "howWeUse": "Bilgilerinizi Nasıl Kullanıyoruz",
      "howWeShare": "Bilgilerinizi Nasıl Paylaşıyoruz",
      "dataRetention": "Veri Saklama",
      "yourRights": "Gizlilik Haklarınız",
      "california": "Kaliforniya Sakinleri (CCPA/CPRA)",
      "cookies": "Çerezler ve Yerel Depolama",
      "security": "Veri Güvenliği",
      "changes": "Bu Politikadaki Değişiklikler",
      "contact": "Bize Ulaşın"
    },
    "headings": {
      "informationWeCollect": "Topladığımız Bilgiler",
      "connectedServices": "Bağlı Hizmetler (Google, Todoist, Apple)",
      "howWeUse": "Bilgilerinizi Nasıl Kullanıyoruz",
      "howWeShare": "Bilgilerinizi Nasıl Paylaşıyoruz",
      "dataRetention": "Veri Saklama",
      "yourRights": "Gizlilik Haklarınız",
      "california": "Kaliforniya Sakinleri (CCPA / CPRA)",
      "cookies": "Çerezler ve Yerel Depolama",
      "security": "Veri Güvenliği",
      "changes": "Bu Politikadaki Değişiklikler",
      "contact": "Bize Ulaşın"
    }
  },
  "deleteAccount": {
    "intro": "Hesabınızı silmek şunları kalıcı olarak kaldırır:",
    "list": {
      "account": "Hesabınız ve profiliniz",
      "tasks": "Tüm görevler",
      "notes": "Tüm notlar",
      "verses": "Kaydedilen ayetler",
      "billing": "Abonelik kayıtları"
    },
    "irreversible": "Bu işlem geri alınamaz.",
    "appleNotice": "Hesabınızı silmek, App Store üzerinden satın alınan bir aboneliği iptal etmez. Lütfen Ayarlar → Apple Kimliği → Abonelikler bölümünden de iptal edin.",
    "manageSubscription": "Aboneliği yönet",
    "continueBtn": "Silmeye devam et",
    "keepBtn": "Hesabımı koru",
    "confirmTitle": "Hesabınız silinsin mi?",
    "confirmDesc": "Hesabınız ve tüm verileri kalıcı olarak silinecek. Bu işlem geri alınamaz.",
    "confirmBtn": "Hesabımı kalıcı olarak sil",
    "deleting": "Siliniyor…",
    "error": "Hesabınızı silemedik. Lütfen bağlantınızı kontrol edip yeniden deneyin."
  }
}
